<template>
<v-app>

  <portal-target name="appbar">
  </portal-target>
  <v-content>
    <router-view></router-view>
  </v-content>
</v-app>
</template>

<script lang="ts">
import PortalVue from 'portal-vue'
import Vue from 'vue';

export default Vue.extend({
  name: "App",
  components: {

  },
  data: () => ({
    sidebar: false
  })
});
</script>

<style scoped>
.v-dialog, .v-btn {
    z-index: 100000001  !important;
    background: red !important;
}


</style>
